export const PROJECTS_VIEW_KEY = 'projects_view'
